import { render, staticRenderFns } from "./CrearCliente.vue?vue&type=template&id=990fb890&scoped=true"
import script from "./CrearCliente.vue?vue&type=script&lang=js"
export * from "./CrearCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990fb890",
  null
  
)

export default component.exports